import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
    EditableSlideToggle,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffCitiesEdit from '../locations/TaroffCitiesEdit';
import { postData } from '../../Api';

export default function TaroffCities(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        applyFilters();
    };
    const [formQProvinceIdOptions, setFormQProvinceIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-cities/select-data/q-province-id').then((response) => {
            setFormQProvinceIdOptions(response.data);
        });
    }, []);
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQProvinceId('');
        setFilterQTitle('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQProvinceId && (newSearchParams['q-province-id'] = filterQProvinceId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQProvinceId, setFilterQProvinceId] = useState(allProps['q-province-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-cities/table-data', {
            size: tableSize,
            page: tablePage,
            q_province_id: filterQProvinceId,
            q_title: filterQTitle,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp2 = (row) => {
        alert('error in editting slide-toggle value')
    };
    const handlecomp3 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffCitiesEdit
                        taroff-cities-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>مدیریت شهر ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <MultiSelectBox
                    label={'استان'}
                    options={formQProvinceIdOptions}
                    value={filterQProvinceId}
                    onChange={setFilterQProvinceId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>عنوان استان</TableColumn>
                        <TableColumn mobile={false}>عنوان اصلی</TableColumn>
                        <TableColumn mobile={false}>عنوان لاتین</TableColumn>
                        <TableColumn mobile={false}>کد شهرستان</TableColumn>
                        <TableColumn mobile={false}>کد گیت وی</TableColumn>
                        <TableColumn mobile={false}>فعال</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_province_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title_original}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title_en}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_county_code}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_gateway_code}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <EditableSlideToggle onChange={() => handlecomp2(row)} />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Button
                                    onClick={() => handlecomp3(row)}
                                    rightIcon={'far fa-edit'}
                                    tooltip={'ویرایش'}
                                ></Button>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
